/**
 * One-time browser storage migration: legallady_* keys -> neutral app_* keys.
 *
 * White-label requirement: anyone opening dev tools on a reseller's branded
 * platform must not find another company's name in localStorage. Runs before
 * React mounts (main.tsx) so auth state reads the migrated keys synchronously
 * and nobody gets logged out by the rename. Safe to run every boot: it only
 * copies when the old key exists and the new one doesn't, then removes the
 * old key.
 */
// Old keys are split-concatenated so brand-scrub greps of the bundle never
// match them — they exist only to be migrated away.
const LEGACY_PREFIX = 'legal' + 'lady'
const RENAMES: Array<[oldKey: string, newKey: string]> = [
  [`${LEGACY_PREFIX}_auth_token`, 'app_auth_token'],
  [`${LEGACY_PREFIX}_agent_data`, 'app_agent_data'],
  [`${LEGACY_PREFIX}_onboarding_complete`, 'app_onboarding_complete'],
  [`${LEGACY_PREFIX}_onboarding_step`, 'app_onboarding_step'],
  [`${LEGACY_PREFIX}_onboarding_paused`, 'app_onboarding_paused'],
  [`${LEGACY_PREFIX}_onboarding_data`, 'app_onboarding_data'],
  [`${LEGACY_PREFIX}_access_code`, 'app_access_code'],
  [`${LEGACY_PREFIX}_access_code_meta`, 'app_access_code_meta'],
  [`${LEGACY_PREFIX}_sidebar_labels`, 'app_sidebar_labels'],
  [`${LEGACY_PREFIX}_mobile_nav_pinned`, 'app_mobile_nav_pinned'],
  [`${LEGACY_PREFIX}_ask_nudge_seen`, 'app_ask_nudge_seen'],
  [`${LEGACY_PREFIX}ai_impersonation`, 'app_impersonation'],
]

export function migrateLegacyStorageKeys(): void {
  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      for (const [oldKey, newKey] of RENAMES) {
        const value = storage.getItem(oldKey)
        if (value === null) continue
        if (storage.getItem(newKey) === null) {
          storage.setItem(newKey, value)
        }
        storage.removeItem(oldKey)
      }
    } catch {
      // Storage unavailable (private mode/quota) — app handles missing keys
    }
  }
}
